import { Icon } from "@iconify/react";
import { useContext } from "react";
import "./propertyGrid.css";
import { Link } from "react-router-dom";
import FilterForm from "../filterForm/filterForm";

const PropertyGrid = (props) => {
  const { properties, isLoading, filterGrid, onFilterSubmit, filteredValues, propertyView } = props;
  const onToogleMenu = () => {
    const element = document.getElementById("cardGrid");
    element.classList.toggle("cardGird-active");
  };
  const propertiesView = () => {
    return properties.data.map((property) => {
      const { id, listingID, cityName, address, sqFt, propStatus, bedrooms, totalBaths, listingPrice } = property.property;
      return (
        <div key={id} className="cardBox">
          <div className="card overflow-hidden">
            <div className="position-relative">
              <img src={property.images[0].full} alt="" className="img-fluid rounded-top" />
              <span className="position-absolute top-0 end-0 p-1">
                <span className="badge bg-success text-white fs-13">{propStatus}</span>
              </span>
            </div>
            <div className="card-body">
              <div className="d-flex align-items-center gap-2">
                <div className="avatar bg-light rounded">
                  <Icon icon="solar:home-bold-duotone" className="fs-24 text-primary avatar-title"></Icon>
                </div>
                <div>
                  <a href="#!" className="text-dark fw-medium fs-16">
                    {cityName}
                  </a>
                  <p className="text-muted mb-0">{address}</p>
                </div>
              </div>
              <div className="row mt-2 g-2">
                <div className="col-lg-4 col-4">
                  <span className="badge bg-light-subtle text-muted border fs-12">
                    <span className="fs-16">
                      <Icon icon="solar:bed-broken" className="align-middle"></Icon>
                    </span>
                    {bedrooms} Beds
                  </span>
                </div>
                <div className="col-lg-4 col-4">
                  <span className="badge bg-light-subtle text-muted border fs-12">
                    <span className="fs-16">
                      <Icon icon="solar:bath-broken" className="align-middle"></Icon>
                    </span>
                    {totalBaths} Bath
                  </span>
                </div>
                <div className="col-lg-4 col-4">
                  <span className="badge bg-light-subtle text-muted border fs-12">
                    <span className="fs-16">
                      <Icon icon="solar:scale-broken" className="align-middle"></Icon>
                    </span>
                    {sqFt} sqft
                  </span>
                </div>
                {/* <div className="col-lg-4 col-4">
                          <span className="badge bg-light-subtle text-muted border fs-12">
                            <span className="fs-16">
                              <Icon
                                icon="solar:double-alt-arrow-up-broken"
                                className="align-middle"
                              ></Icon>
                            </span>
                            3 Floor
                          </span>
                        </div> */}
              </div>
            </div>
            <div className="card-footer bg-light-subtle d-flex justify-content-between align-items-center border-top">
              <p className="fw-medium text-dark fs-16 mb-0">{listingPrice}</p>
              <div>
                <Link to={`/property-details/${listingID}`} className="link-primary fw-medium">
                  More Inquiry
                  <i className="ri-arrow-right-line align-middle"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  const propertyLoadingView = () => {
    return (
      <div className="property-loader preloader">
        <div class="loading">
          <div class="loading__letter">L</div>
          <div class="loading__letter">o</div>
          <div class="loading__letter">a</div>
          <div class="loading__letter">d</div>
          <div class="loading__letter">i</div>
          <div class="loading__letter">n</div>
          <div class="loading__letter">g</div>
          <div class="loading__letter">.</div>
          <div class="loading__letter">.</div>
          <div class="loading__letter">.</div>
        </div>
      </div>
    );
  };

  const noPropertyView = () => {
    return (
      <div className="no-data-found">
        <Icon icon="solar:home-broken" className="fs-32 text-primary avatar-title no-property-icon"></Icon>
        No Properties Found
      </div>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return propertyLoadingView();
    } else if (properties.status === "Not Found") {
      return noPropertyView();
    } else if (properties.status === "Success") {
      return propertiesView();
    }
  };
  return (
    <>
      {/* <button type="button" className="cardHamburger" onClick={onToogleMenu}>
        <i className="ri-menu-2-line fs-24"></i>
      </button> */}
      <div id="cardGrid" className="cardGird cardGird-active">
        <div className="cardSidebar">
          <div className="card ">
            <div className="card-header border-bottom">
              <div>
                <h4 className="card-title">{properties.pagination !== undefined ? properties.pagination.total : 0} Properties Available</h4>
              </div>
            </div>
            <div className="card-body border-light">
              <FilterForm filteredValues={filteredValues} filterGrid={filterGrid} onFilterSubmit={onFilterSubmit} propertyView={propertyView} />
            </div>
          </div>
        </div>
        <div className="cardDetail">{renderView()}</div>
      </div>
    </>
  );
};

export default PropertyGrid;
